// extracted by mini-css-extract-plugin
module.exports = {"modalMainWrp":"style_modalMainWrp__lV_TP","modalBodyWrp":"style_modalBodyWrp__3hWiF"};